import IconDollar from 'src/assets/images/icons/analytic-dollar.svg';
import IconSort from 'src/assets/images/icons/analytic-sort.svg';
import IconTruck from 'src/assets/images/icons/analytic-truck.svg';
import IconReceipt from 'src/assets/images/icons/analytic-receipt.svg';
import IconWarning from 'src/assets/images/icons/analytic-warning-error.svg';
import IconNewIssues from '/src/assets/images/icons/analytic-warning-error.svg';
import IconIssuesUnderReview from '/src/assets/images/icons/internal-dashboard-issues-under-review.svg';
import IconFileIngestionFailures from '/src/assets/images/icons/internal-dashboard-file-ingestion-failures.svg';
import IconTotalFilesUploaded from '/src/assets/images/icons/internal-dashboard-total-files-uploaded.svg';
import IconExtractedPages from '/src/assets/images/icons/internal-dashboard-extracted-pages.svg';
import { SimpleFormatNumber } from 'src/utils/utility';
import { AdminDashboardMetricDto, KeyMetricsResponseDto } from 'src/generated/services/TFinancialApi';
import { CardTheme, ChartType, ICardAnalyticItemProps } from '../../molecules/card/cardAnalytic/types';
import { CardId } from '../../organisms/analytics/generalOverview/types';

const getTotalDeviationValue = (value: number, currency: string) => {
  if (value === 0) {
    return <span>{SimpleFormatNumber(value, currency === 'JPY', 2)}</span>;
  }
  if (!value) {
    return 'N/A';
  }
  return <span className='text-red-40'>-{SimpleFormatNumber(value, currency === 'JPY', 2)}</span>;
};

export const dashboardMetricsMapper = (dataStats: KeyMetricsResponseDto): ICardAnalyticItemProps[] => [
  {
    id: CardId.TOTAL_AMOUNT,
    count: SimpleFormatNumber(dataStats?.keymetrics?.totalAmount?.afterTax, dataStats?.keymetrics?.totalAmount?.currency === 'JPY', 2),
    title: 'Total Amount',
    icon: IconDollar,
    theme: CardTheme.ORANGE,
    chartType: ChartType.LINE,
    unit: dataStats?.meta?.currency,
  },
  {
    id: CardId.TOTAL_DEVIATION_AMOUNT,
    count: getTotalDeviationValue(dataStats?.keymetrics?.totalDeviationAmount?.afterTax, dataStats?.keymetrics?.totalDeviationAmount?.currency),
    title: 'Total Net Deviation Amount',
    icon: IconWarning,
    theme: CardTheme.RED,
    chartType: ChartType.LINE,
    unit: dataStats?.meta?.currency,
  },
  {
    id: CardId.NO_SHIPMENTS,
    count: SimpleFormatNumber(dataStats?.keymetrics?.noShipments),
    title: 'Flagged Shipments',
    icon: IconTruck,
    theme: CardTheme.PURPLE,
    chartType: ChartType.BAR,
    unit: '#',
  },
  {
    id: CardId.NO_INVOICES,
    count: SimpleFormatNumber(dataStats?.keymetrics?.noInvoices),
    title: 'Flagged Invoices',
    icon: IconReceipt,
    theme: CardTheme.PURPLE_LIGHT,
    chartType: ChartType.BAR,
    unit: '#',
  },
  {
    id: CardId.NO_CHARGES,
    count: SimpleFormatNumber(dataStats?.keymetrics?.noCharges),
    title: 'Flagged Charge Lines',
    icon: IconSort,
    theme: CardTheme.PINK,
    chartType: ChartType.BAR,
    unit: '#',
  },
];

const getNewIssuesValue = (value: number) => {
  const simpleFormatNumber = SimpleFormatNumber(value);
  if (value === 0) {
    return simpleFormatNumber;
  }
  return <span className='text-red-40'>{simpleFormatNumber}</span>;
};

export const internalDashboardMetricMapper = (metrics: AdminDashboardMetricDto): ICardAnalyticItemProps[] => [
  {
    id: CardId.NEW_ISSUES,
    count: getNewIssuesValue(metrics?.newIssues),
    title: 'New Issues',
    icon: IconNewIssues,
    theme: CardTheme.RED,
    chartType: ChartType.BAR,
    unit: '#',
  },
  {
    id: CardId.ISSUES_UNDER_REVIEW,
    count: SimpleFormatNumber(metrics?.issuesUnderReview),
    title: 'Issues Under Review',
    icon: IconIssuesUnderReview,
    theme: CardTheme.ORANGE,
    chartType: ChartType.BAR,
    unit: '#',
  },
  {
    id: CardId.FILE_INGESTION_FAILURES,
    count: SimpleFormatNumber(metrics?.fileIngestionFailures),
    title: 'File Ingestion Failures',
    icon: IconFileIngestionFailures,
    theme: CardTheme.NEUTRAL,
    chartType: ChartType.BAR,
    unit: '#',
  },
  {
    id: CardId.TOTAL_FILES_UPLOADED,
    count: SimpleFormatNumber(metrics?.totalFilesUploaded),
    title: 'Total Files Uploaded',
    icon: IconTotalFilesUploaded,
    theme: CardTheme.BLUE_LIGHT,
    chartType: ChartType.LINE,
    unit: '#',
  },
  {
    id: CardId.EXTRACTED_PAGES,
    count: SimpleFormatNumber(metrics?.extractedPages),
    title: 'Extracted Pages',
    icon: IconExtractedPages,
    theme: CardTheme.PURPLE_LIGHT,
    chartType: ChartType.LINE,
    unit: '#',
  },
];
